module.exports = __webpack_public_path__ + "static/media/Garota.a0d50803.png";